import styled from 'styled-components';
import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';

import Descricoes1 from '../Descricoes1';


function QuatroBanner({item,DadosAPI }) {

   

    //Navegacao lista de pordutos

    const navigate = useNavigate();


    return (
         <>
                <Descricoes1 Item={item}/>
         </>
    );
}

export default QuatroBanner;
